import type { Editor } from '@tiptap/core'
import { TmTiptapEditor } from '@/services/forms/tmTiptap/tmTiptapEditor'
import { TmTiptapEditorError } from '@/core/error/tmTiptapEditorError'

export const isTmTiptapEditor = (value: unknown): value is TmTiptapEditor => {
  return value instanceof TmTiptapEditor
}

export const verifyTmTiptapEditor = (value: unknown): TmTiptapEditor => {
  if (!isTmTiptapEditor(value)) {
    throw new TmTiptapEditorError('Value should be an instance of TmTiptapEditor')
  }
  return value
}
export const getChainWithPossibleFocus = (editor: TmTiptapEditor | Editor, withFocus: boolean) =>
  withFocus ? editor.chain().focus(undefined, { scrollIntoView: false }) : editor.chain()

export const getEditorRootParent = (editorParam: unknown): HTMLDivElement => {
  const editor = verifyTmTiptapEditor(editorParam)
  const editorRoot = editor.view.dom
  if (!(editorRoot instanceof HTMLDivElement) || !(editorRoot.parentElement instanceof HTMLDivElement)) {
    throw new TmTiptapEditorError('Expected editor root parent element to be a HTMLDivElement')
  }
  return editorRoot.parentElement
}
